import * as types from "./mutation-types";
import { rolesObj } from "../../../roleDefinitions";

const actions = {
  setAdminType({ commit }, adminLevel) {
    if (adminLevel >= rolesObj.coreTierAdmin.number) {
      commit(types.SET_IS_ADMIN, true);
    } else {
      commit(types.SET_IS_NON_ADMIN, true);
    }

    if (adminLevel >= rolesObj.wtAdmin.number) {
      commit(types.SET_IS_WT_ADMIN, true);
    }

    if (adminLevel === rolesObj.superWtAdmin.number) {
      commit(types.SET_IS_WT_ADMIN_SUPER, true);
    }
  },

  setPasswordChanged({ commit }, status) {
    commit(types.SET_PASSWORD_CHANGED, status);
  },

  setIsTeamLeader({ commit }, status) {
    commit(types.SET_IS_TEAM_LEADER, status);
  }
};

export default actions;
